import styled, {keyframes} from "styled-components";

const rotate = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;
export const Container = styled.div`
    align-items: ${props => props.$aling ? props.$aling : 'center;'};
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 16px 0;
    width: 100%;
`;

export const ContainerInput = styled.div`
    align-items: center;
    border-radius: 10px;
    display: flex;
    gap: 8px;
    justify-content: flex-start;
    /* padding: 2px 12px 2px 12px; */
    position: relative;
    width: 100%;
`;

export const CheckboxInput = styled.input.attrs({ type: 'checkbox' })`
    opacity: 0;
    position: absolute;
`;

export const CheckboxMark = styled.span`
    background-color: ${props => (props.checked ? '#33CC99' : 'transparent')};
    border: 2px solid ${props => (props.$disabled ? '#A3A3A3' : '#33CC99')};
    border-radius: 4px;
    cursor: pointer;
    display: inline-block;
    height: 20px;
    min-height: 20px;
    min-width: 20px;
    position: relative;
    width: 20px;
    
    &:after {
        color: white;
        content: ${props => (props.checked ? "'\\2714'" : "''")};
        display: ${props => (props.checked ? 'block' : 'none')};
        font-size: 14px;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
    }
`;

export const Text = styled.span` 
    color: ${props => (props.$disabled ? '#A3A3A3' : '#333')};;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    @media (min-width: 720px) {
        font-size: 20px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 16px;
    }
`;

export const Spinner = styled.div`
    animation: ${rotate} 1s linear infinite;
    border: 10px solid rgba(0, 0, 0, 0.1);
    border-left-color: #006560;
    border-radius: 50%;
    height: 20px;
    width: 20px;
`;